import type { PropsWithChildren, FC } from 'react';
import { useEffect, useState, useRef } from 'react';

import { BrowserBarOpenContext } from '@xing-com/hub';

export const BrowserBarOpenModule: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [isBrowserBarOpen, setIsBrowserBarOpen] = useState(true);
  const prevInnerHeight = useRef(0);

  useEffect(() => {
    // we need to gather the render size on component mount
    prevInnerHeight.current = window.innerHeight;
  }, []);

  useEffect(() => {
    const onResize = (): void => {
      const isScrollable =
        window.document.documentElement.scrollHeight >
        window.document.documentElement.clientHeight;

      const heightDiff = window.innerHeight - prevInnerHeight.current;

      if (Math.abs(heightDiff) > 10) {
        setIsBrowserBarOpen(!isScrollable || heightDiff < 0);
        prevInnerHeight.current = window.innerHeight;
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <BrowserBarOpenContext.Provider value={isBrowserBarOpen}>
      {children}
    </BrowserBarOpenContext.Provider>
  );
};
